import { useState } from 'react'

import { useAuth0 } from '@auth0/auth0-react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import LogoutIcon from '@mui/icons-material/Logout'
import { IconButton, ListSubheader, Menu, MenuItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type ProfileMenuProps = Readonly<{
  backgroundColor: string
}>

export const ProfileMenu: React.FC<ProfileMenuProps> = ({ backgroundColor }) => {
  const { t } = useTranslation()
  const { user, logout } = useAuth0()
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const opened = anchor !== null

  const logOut = () => {
    localStorage.clear()
    logout()
    if (window.Sprig) {
      window.Sprig('logoutUser')
    }
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={({ currentTarget }) => setAnchor(currentTarget)}
        disableRipple
        disableFocusRipple
        sx={{ ':hover': { background: 'none' } }}
      >
        <AccountCircleOutlinedIcon fontSize="medium" sx={{ color: 'secondary.main' }} />
      </IconButton>
      <Menu
        open={opened}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        disableScrollLock
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        slotProps={{
          paper: { sx: { backgroundColor, border: '1px solid', borderColor: 'tertiary.main' } },
        }}
        MenuListProps={{ sx: { paddingBottom: 0 } }}
      >
        <ListSubheader sx={{ backgroundColor: 'inherit', marginBottom: 1 }}>
          <Typography variant="subtitle1" color="text.disabled">
            {t('applicationBar.profileMenu.signedInAs')}
          </Typography>
          <Typography color="text.secondary" sx={{ fontWeight: 'bold', fontSize: 'small' }}>
            {user?.email}
          </Typography>
        </ListSubheader>
        <MenuItem
          onClick={logOut}
          sx={{
            fontSize: 'small',
            fontWeight: 'bold',
            lineHeight: 1,
            color: 'text.secondary',
            gap: 1,
            borderTop: '1px solid',
            borderTopColor: 'tertiary.main',
            padding: 1.3,
            ':hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' },
          }}
        >
          <LogoutIcon fontSize="small" />
          {t('applicationBar.profileMenu.logout')}
        </MenuItem>
      </Menu>
    </>
  )
}
